import instance from './instance';

export const createWorkspaceAiSetting = ({ workspaceId, data }) =>
  instance.post(`/workspaces/${workspaceId}/workspace_ai_settings`, data);

export const updateWorkspaceAiSetting = ({ workspaceId, workspaceAiSettingSlug, data }) =>
  instance.put(`/workspaces/${workspaceId}/workspace_ai_settings/${workspaceAiSettingSlug}`, data);

export const deleteWorkspaceAiSetting = ({ workspaceId, workspaceAiSettingSlug }) =>
  instance.delete(`/workspaces/${workspaceId}/workspace_ai_settings/${workspaceAiSettingSlug}`);
